module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="background">\n	<div class="form-container">\n		<form class="base-form js-change-password-form">\n			<h1>Change your Fantasy Password</h1>\n			<p>You’re almost there. Please now choose another password for your old Fantasy account. You can then use this password to complete the linking with your new NRL Account, allowing you to retain your team and league history.</p>\n			<div class="form-group">\n				<label for="password">Password *</label>\n				<input type="password" id="password" name="password" class="js-password" value="'+
((__t=( password ))==null?'':_.escape(__t))+
'">\n				';
 if (errors && errors.password) { 
__p+='\n					<div class="error">'+
((__t=( errors.password[0] ))==null?'':__t)+
'</div>\n				';
 } 
__p+='\n				';
 if (errors && errors.server_side) { 
__p+='\n					<div class="error">'+
((__t=( errors.server_side[0] ))==null?'':__t)+
'</div>\n				';
 } 
__p+='\n			</div>\n			<p>Remember: Once this link is complete you will only need to use your new NRL Account to login to NRL Fantasy in the future.</p>\n			<div class="buttons-wrapper">\n				<button type="submit" class="btn primary-btn js-change">Change password</button>\n			</div>\n		</form>\n	</div>\n</div>\n';
}
return __p;
};
